import ModifierGroupEdit from "pages/secure/facility/settings/modifierGroup/ModifierGroupEdit";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

export default connect(null, mapDispatchToProps)(ModifierGroupEdit);
